import { render, staticRenderFns } from "./kw_btn_array.vue?vue&type=template&id=b899b792&scoped=true&"
import script from "./kw_btn_array.vue?vue&type=script&lang=js&"
export * from "./kw_btn_array.vue?vue&type=script&lang=js&"
import style0 from "./kw_btn_array.vue?vue&type=style&index=0&id=b899b792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899b792",
  null
  
)

component.options.__file = "kw_btn_array.vue"
export default component.exports